module.exports = __webpack_public_path__ + "img/129.62e91e99.jpg";